import React from 'react'

const t = (key, options) => I18n.t(`invoices.accounting_export.modal.${key}`, options)

const Checkbox = ({ id, name, checked, onChange, label, hint }) => (
  <div className = "mb-2">
    <div className = "checkbox checkbox-primary mb-0">
      <input type = "hidden" name = {name} value = "0" />
      <input
        type     = "checkbox"
        id       = {id}
        name     = {name}
        value    = "1"
        checked  = {checked}
        onChange = {e => onChange(e.target.checked)}
      />
      <label className = "control-label" htmlFor = {id}>{label}</label>
    </div>
    {hint && <div className = "text-muted small" style = {{ marginLeft: 28 }}>{hint}</div>}
  </div>
)

const AccountingExportOptions = ({
  selectedCount,
  exportedCount,
  exportableCount,
  exclude,
  setExclude,
  mark,
  setMark
}) => (
  <div className = "form-group mt-2 mb-3 p-3" style = {{ border: "1px solid #e5e7eb", borderRadius: 6 }}>
    <label className = "form-label mb-2"><i className = "fas fa-file-export mr-1" />{t("title")}</label>

    {exportedCount > 0 && (
      <>
        <p className = "small mb-2">
          <i className = "fas fa-info-circle text-primary mr-1" />
          {t("already_exported", { count: exportedCount, total: selectedCount })}
        </p>

        <Checkbox
          id       = "exclude-accounting-exported"
          name     = "exclude_accounting_exported"
          checked  = {exclude}
          onChange = {setExclude}
          label    = {t("exclude", { count: exportedCount })}
          hint     = {exclude ? t("exclude_hint_on") : t("exclude_hint_off")}
        />
      </>
    )}

    {exportableCount === 0
      ? <p className = "small text-danger mb-0">{t("nothing_left")}</p>
      : <Checkbox
          id       = "mark-accounting-exported"
          name     = "mark_accounting_exported"
          checked  = {mark}
          onChange = {setMark}
          label    = {t("mark", { count: exportableCount })}
          hint     = {mark ? t("mark_hint_on") : t("mark_hint_off")}
        />
    }
  </div>
)

export default AccountingExportOptions
